import type { DNClientVersion, VersionInfo } from '#dn-types/downloads.ts';
import { get } from './fetch.ts';

type Latest = { latest: DNClientVersion };

// GET /downloads
export type GetDownloadsResult = {
  dnclient: Latest & {
    [version: string]: DNClientVersion;
  };
  mobile: {
    android: string;
    ios: string;
  };
  container: {
    docker: string;
  };
  versionInfo: VersionInfo;
};
export function getDownloads(init?: RequestInit) {
  return get<GetDownloadsResult>('/v1/downloads', { ...init, headers: { Authorization: '' } });
}
